export const dashBoardTourSteps = [
  {
    target: '#help-fab-button',
    content: `Discover <b>AlgoReady</b> by taking the tour!`
  },
  {
    target: '#topSearch',
    content: 'Search here for any stock, investor, portfolio.'
  },
  {
    target: '#addPortfolio',
    content: 'Add your portfolios here. Upload a picture or a csv file.'
  },
  {
    target: '#Likes',
    content: 'Manage your preferences here. Tell us stocks you like and dislike to improve the recommendations we provide.'
  },
  {
    target: '#searchStocks',
    content: 'Search for a stock and get insights on demand, performance and volume.'
  },
  {
    target: '#addPortfolioDashboard',
    content: 'Add your portfolios by uploading a picture or a csv file.'
  },
  {
    target: '#searchInvestors',
    content: 'Search for an investor and get insights on its behavior.'
  },
  {
    target: '#contact',
    content: 'Contact us to give feedback, your help is greatly appreciated.'
  },
]

export const stockAnalyzeTourSteps = [
  {
    target: '#help-fab-button',
    content: `Discover Stock analysis page by taking the tour!`
  },
  {
    target: '#insights',
    content: 'Read insights on stock here about its pressure, exposure, performance and abnormal volume breakdown by factor.'
  },
  {
    target: '#pressure',
    content: 'Chart of the historical demand on the stock. This comes from our proprietary model and helps you quantify the estimated demand on the stock. Updated monthly currently and weekly when we will be live.'
  },
  {
    target: '#similarStocks',
    content: 'Lists similar stocks. These stocks are usually traded together and might be correlated in case of market downturn.'
  },
  {
    target: '#likelyBuyers',
    content: 'Reference which investor might be interested to buy this stock and for how much in terms of days to trade. See if these investors are similar to you (based on your uploaded portfolios) and their classification.'
  },
  {
    target: '#likelySellers',
    content: 'Reference which investor might dislike this stock and for how much in terms of days to trade. See if these investors are similar to you (based on your uploaded portfolios) and their classification.'
  },
  {
    target: '#performance',
    content: 'Breakdown by factor of the stock performance.'
  },
  {
    target: '#volume',
    content: 'Breakdown of the abnormal volume above median 90days by factor. This chart gives insights on the type of investor who participated in the stock volume increase.'
  },
  {
    target: '#style',
    content: 'See decile exposure (from 1 to 10) of the stock to factors. Higher decile means higher exposure to the factor.'
  },
  {
    target: '#ownership',
    content: 'See latest table of stock ownership.'
  },
]

export const inverstorAnalyzeTourSteps = [
  {
    target: '#help-fab-button',
    content: 'Discover Investor analysis page by taking the tour!'
  },
  {
    target: '#insights',
    content: 'Read insights on investor here about its exposure, performance and abnormal volume breakdown by factor.'
  },
  {
    target: '#similarInvestors',
    content: 'Lists similar investors. Overlap is calculated as a combination of holdings, country, sector and factor styles overlaps.'
  },
  {
    target: '#performance',
    content: 'Breakdown by factor of the investor performance.'
  },
  {
    target: '#style',
    content: 'See decile exposure (from 1 to 10) of the investor to factors. Higher decile means higher exposure to the factor.'
  },
  {
    target: '#volume',
    content: 'Breakdown of the abnormal volume above median 90days by factor. This chart gives insights on the type of investor who participated in this investor holdings volume increase.'
  },
  {
    target: '#mightLike',
    content: 'Custom stock purchase recommendations for this investor.'
  },
  {
    target: '#mightLinkConstraints-0',
    content: 'Indicates why this recommendation is provided and if this stock fits the investor’s investment strategy in terms of style.'
  },
  {
    target: '.recentBuyers',
    content: 'Click here to understand what drives this recommendation ie which similar investors bought the stock in the past.'
  },
  {
    target: '#mightAvoid',
    content: 'Custom recommendations on which stocks this investor might avoid.'
  },
  {
    target: '#mightAvoidConstraints-0',
    content: 'Indicates why this recommendation is provided and if this stock fits the investor’s investment strategy in terms of style.'
  },
  {
    target: '.recentSellers',
    content: 'Click here to understand what drives this recommendation ie which similar investors sold the stock in the past.'
  },
  {
    target: '#sector-expo',
    content: 'Top 10 sectors for this investor portfolio. Click on the chart icons to see if these exposures are within similar investor’s typical range.'
  },
  {
    target: '#country-expo',
    content: 'Top 10 countries for this investor portfolio. Click on the chart icons to see if these exposures are within similar investor’s typical range.'
  },
  {
    target: '#portfolio',
    content: "Check investor latest calculated portfolio here."
  },
]

const portfolioAnalyzeTourSteps = [
  {
    target: '#help-fab-button',
    content: 'Discover Portfolio analysis page by taking the tour!'
  },
  {
    target: '#daysToTrade',
    content: "Aggregated calculated days to trade on portfolio. Higher decile (from 1 to 10) means more potential demand for the stocks in the portfolio."
  },
  {
    target: '#insights',
    content: "Read insights on portfolio here about its exposure, performance and abnormal volume breakdown by factor."
  },
  {
    target: '#performance',
    content: "Breakdown by factor of the portfolio performance."
  },
  {
    target: '#style',
    content: "See decile exposure (from 1 to 10) of the investor to factors. Higher decile means higher exposure to the factor."
  },
  {
    target: '#volume',
    content: "Breakdown of the abnormal volume above median 90days by factor. This chart gives insights on the type of investor who participated in this investor holdings volume increase."
  },
  {
    target: '#highestPressure',
    content: "Lists stocks with highest buying pressure in the portfolio. Click on any stock to understand what is driving the demand."
  },
  {
    target: '#lowestPressure',
    content: "Lists stocks with lowest buying pressure in the portfolio. Click on any stock to understand what is driving the demand."
  },
  {
    target: '#mightLike',
    content: "Custom stock purchase recommendations for this portfolio."
  },
  {
    target: '#mightLikeConstraints',
    content: "Indicates why this recommendation is provided and if this stock fits the portfolio’s investment strategy in terms of style."
  },
  {
    target: '#mightLikeRecentBuyers',
    content: "Click here to understand what drives this recommendation ie which similar investors bought the stock in the past."
  },
  {
    target: '#mightAvoid',
    content: "Custom recommendations on which stocks this portfolio might avoid."
  },
  {
    target: '#mightAvoidConstraints',
    content: "Indicates why this recommendation is provided and if this stock fits the portfolio’s investment strategy in terms of style."
  },
  {
    target: '#mightAvoidRecentSellers',
    content: "Click here to understand what drives this recommendation ie which similar investors sold the stock in the past."
  },
  {
    target: '#similarInvestors',
    content: "Lists similar investors. Overlap is calculated as a combination of holdings, country, sector and factor styles overlaps."
  },
  {
    target: '#sectorExpo',
    content: "Top 10 sectors for this portfolio. Click on the chart icons to see if these exposures are within similar investor’s typical range."
  },
  {
    target: '#country-expo',
    content: "Top 10 countries for this portfolio. Click on the chart icons to see if these exposures are within similar investor’s typical range."
  },  
  {
    target: '#portfolio',
    content: "Check portfolio full list of constituents here."
  }
]

export const algoReadyTourSteps = {
  dashboard: dashBoardTourSteps,
  stockAnalyze: stockAnalyzeTourSteps,
  inverstorAnalyze: inverstorAnalyzeTourSteps,
  portfolioAnalyze: portfolioAnalyzeTourSteps
}
